import { useQuery } from "@tanstack/react-query";
import { rankingApi } from "@bw/shared/api";
import type { AchievementResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A player's achievements (GET /ranking/achievements/{userId}). Disabled until a
 * userId resolves. AchievementList renders one badge per item, labelled from the
 * server `type` — no fabricated awards.
 */
export function useAchievements(userId: string | undefined) {
  return useQuery<AchievementResponse[]>({
    queryKey: queryKeys.compete.achievements(userId ?? ""),
    queryFn: () => rankingApi.getAchievements(userId as string),
    enabled: Boolean(userId),
  });
}
